module.exports = __webpack_public_path__ + "img/stand-model.a7e95170.png";